import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Designer } from '../../../types/designer';
import { UniversalState } from '../../../types/state';
import API from '../../../util/api';

export const fetchDesignerThunk = createAsyncThunk('designer/fetchDesigner', async () => {
  const result = await API.get('designer');
  return result.data as Designer[];
});

const initialState: UniversalState<Designer[]> = {
  data: [],
  loading: false,
  error: null,
};

const designerSlice = createSlice({
  name: 'designer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDesignerThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchDesignerThunk.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
    builder.addCase(fetchDesignerThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action;
    });
  },
});

const { reducer } = designerSlice;

export default reducer;
